<template>
	<div class="c-m-audio">
		<audio 
			ref="audio"
			:src="src"
			@loadedmetadata="onLoadedmetadata"
			@canplay="onCanplay"
			@timeupdate="onTimeupdate">
			您的浏览器版本过低，不识别audio标签
		</audio>
		<div class="flex flex-main-justify control">
			<span class="status prev" @click="stepPlayer(-10)"></span>
			<span 
				:class="['status', status ? 'play' : 'pause']"
				@click="onToggle">
			</span>
			<span class="status next" @click="stepPlayer(10)"></span>
		</div>
		
		<span 
			ref="bar" 
			class="bar"
			@click="onBarClick($event)">
			<span class="buffer" :style="{width: bw_f}"></span>
			<span class="progress" :style="{width: pw_c_f}"></span>
			<span 
				ref="dot" 
				class="dot" 
				:style="{left: dl_f}"
				@touchstart="onStart($event)"
				@touchmove="onMove($event)"
				@touchend="onEnd($event)">
			</span>
		</span>
		<span class="time-c">{{currentTime_f}}</span>
		<span class="time-t">{{duration_f}}</span>
	</div>
</template>

<script>

function timeFormat(time) {
	let t1 = Math.floor(time / 60);
	let t2 = Math.floor(time % 60);
	if(t1 < 10) {
		t1 = "0" + t1;
	}
	if(t2 < 10) {
		t2 = "0" + t2;
	}
	return t1 + ":" + t2;
}

export default {
	props: {
		src: {
			type: String,
			default: "",
		},
		totalTimes: {
			type: String,
			default: "",
		}
	},
	data: function() {
		return {
			// 播放状态(0:暂停; 1:播放中)
			status: 1,
			// 播放进度
			currentTime: 0,
			// 时长
			duration: 0,
			// 缓冲区域的宽度
			bw: 0,
			// 进度条总宽度
			pw_t: 0,
			// 播放进度宽度
			pw_c: 0,
			// dot 左侧的宽度
			dw: 0,
			// dot 左侧left距离
			dl: 0,
			// 是否正在拖动
			moving: false,
		};
	},
	computed: {
		currentTime_f: function() {
			return timeFormat(this.currentTime);
		},
		duration_f: function() {
			let totalTime = timeFormat(this.duration);
			if (totalTime === "00:00") {
				totalTime = this.totalTimes
			}
			return totalTime;
		},
		// 缓冲进度条宽度
		bw_f: function() {
			return this.bw + "px";
		},
		// 播放进度条宽度
		pw_c_f: function() {
			return this.pw_c + "px";
		},
		// dot 走过的距离 left值
		dl_f: function() {
			return this.dl + "px";
		}
	},
	mounted: function() {
		// this.pw_t = this.$refs.bar.offsetWidth;
		// this.dw = this.$refs.dot.offsetWidth;
		// this.dl = - this.dw / 2;
		// let audio = this.$refs.audio;
		// console.log(audio.duration)
		this.$nextTick(() => {
			this.pw_t = this.$refs.bar.offsetWidth;
			this.dw = this.$refs.dot.offsetWidth;
			this.dl = - this.dw / 2;
			let audio = this.$refs.audio;
			console.log('pw_t', pw_t,'dw', dw, 'dl', dl, 'audio.duration', audio.duration)
			// audio.addEventListener('canplay',this.onCanplay,false);
    })
	},
	methods: {
		/** 监听loadedmetadata，更新音频时长 */
		onLoadedmetadata: function() {
			let audio = this.$refs.audio;
			let readyState = audio.readyState;
			let duration = audio.duration;
			if((readyState === 1 || readyState === 4) && duration && duration !== 1) {
				this.duration = duration;
			}
		},
		/** 监听canplay事件，更新缓冲进度 */
		onCanplay: function() {
			let vm = this;
			let audio = vm.$refs.audio;
			vm.pw_t = vm.$refs.bar.offsetWidth;
			let bufferTimer = setInterval(function() {
				if(audio.buffered && (audio.buffered == undefined)) {
					return;
				}
				let bufferIndex = audio.buffered.length;
				if(bufferIndex > 0) {
					vm.bw = audio.buffered.end(bufferIndex - 1) / audio.duration * vm.pw_t;
					if(Math.abs(audio.duration - audio.buffered.end(bufferIndex - 1)) < 1) {
						vm.bw = vm.pw_t;
						clearInterval(bufferTimer);
					}
				}
			});
			console.log("onCanplay",audio.buffered.end(audio.buffered.length - 1))

			console.log("onCanplay pw_t",vm.pw_t)
		},
		/** 监听timeupdate，更新播放进度 */
		onTimeupdate: function() {
			let audio = this.$refs.audio;
			let duration = audio.duration;
			let currentTime = audio.currentTime;
			if(currentTime != 0 & !isNaN(duration)) {
				if(!this.duration) {
					this.duration = duration;
				}
				this.currentTime = currentTime;
				this.pw_c = currentTime / duration * this.pw_t;
				if(!this.moving) {
					this.dl = this.pw_c - this.dw / 2;
				}
				if(audio.ended) {
					this.resetPlayer();
				}
			}

		},
		/** 监听播放按钮的点击事件，切换播放状态 */
		onToggle: function() {
			let audio = this.$refs.audio;
			// ios 無效
			// if(isNaN(audio.duration)) {
			// 	return;
			// }
			if (this.status === 0) {
				this.status = 1
				audio.pause()
			} else {
				this.status = 0
				audio.play()
			}
		},
		/** 监听拖动开始 */
		onStart: function($event) {
			if(!this.bw) {
				return;
			}
			this.moving = true;
			this.dot_sx = $event.targetTouches && $event.targetTouches.length ? $event.targetTouches[0].pageX : $event.pageX;
			this.dl_s = this.dl;
		},
		/** 监听拖动中 */
		onMove: function($event) {
			this.dot_nx = $event.targetTouches && $event.targetTouches.length ? $event.targetTouches[0].pageX : $event.pageX;
			let range = this.dot_nx - this.dot_sx;
			if(range > 0) {
				if((this.dl_s + range) < this.pw_t) {
					this.dl = this.dl_s + range;
				}
				else {
					this.dl = this.pw_t - this.dw / 2;
				}
			}
			else if(range < 0) {
				if((this.dl_s + range) < 0) {
					this.dl = - this.dw / 2;
				}
				else {
					this.dl = this.dl_s + range;
				}
			}
		},
		/** 监听拖动结束 */
		onEnd: function($event) {
			let audio = this.$refs.audio;
			let duration = audio.duration;
			audio.currentTime = (this.dl / this.pw_t) * duration;
			this.moving = false;
		},
		/** 监听进度条点击事件 */
		onBarClick: function($event) {
			if(!this.bw) {
				return;
			}
			let audio = this.$refs.audio;
			let duration = audio.duration;
			this.dl = $event.clientX - this.$refs.bar.getBoundingClientRect().left;
			audio.currentTime = this.dl / this.pw_t *duration;
		},
		/** 前进后退点击事件 */
		stepPlayer: function(val) {
			let audio = this.$refs.audio;
			let duration = audio.duration;
			let step = this.pw_t/duration *10
			if(val > 0){
				if(this.currentTime + 10 > duration){
					// this.currentTime = duration 
					audio.currentTime = duration
					this.currentTime = 0
				  // this.dl =  this.pw_t - this.dw / 2 
					// this.status = 1;
					// audio.pause();
				}else{
					audio.currentTime = this.currentTime == 0? this.currentTime:audio.currentTime
					this.currentTime = audio.currentTime + 10
					audio.currentTime = this.currentTime
				  this.dl = this.dl+step 
				}
			} else {
				if(this.currentTime == 0) return
				if(this.currentTime - 10 < 0){
					this.currentTime = 0 
					audio.currentTime = this.currentTime
				  this.dl = - this.dw / 2 
				}else{
					this.currentTime = audio.currentTime - 10
					audio.currentTime = this.currentTime
				  this.dl = this.dl - step 
				}
			}			
		},
		/** 重置播放器 */
		resetPlayer: function() {
			let audio = this.$refs.audio;
			this.currentTime = 0;
			this.pw_c = 0;
			this.dl = - this.dw / 2;
			this.status = 1;
			audio.pause();
		}
	},
	watch: {
      totalTimes(val, oldVal) {
		  console.log('val',val)
        // this.totalTimes = this.totalTimes;
      }
    }
}

</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.c-m-audio 
	position relative
	padding 0 40px
	height 280px
	font-size 28px
	color #E02829
	background #F6F6F6
	-webkit-touch-callout none
	-webkit-user-select none
	user-select none
	audio 
		display none
	span 
		display inline-block
		vertical-align middle
	.control
		padding 0 122px
	.status 
		display inline-block
		width 72px
		height 72px
		background-repeat no-repeat
		background-position center center
		background-size 100%
		margin-top 54px
		cursor: pointer
	.play 
		background-image url("~images/icon_audio_play.png")
	.pause 
		background-image url("~images/icon_audio_stop.png")
	.prev 
		background-image url("~images/icon_audio_back10.png")
	.next 
		background-image url("~images/icon_audio_go10.png")
	.time-c 
		margin-top 60px
		float left
		line-height 80px
	.time-t 
		margin-top 60px
		float right
		line-height 80px
		margin-right 10px
	.bar 
		position absolute
		left 52px
		right 52px
		top 178px
		height 4px
		border-radius 2px
		background #FFFFFF
		cursor: pointer
		.progress 
			position absolute
			top 0
			left 0
			height 100%
			border-radius 2px	
		.buffer 
			background #FD848D
			z-index 2
			position absolute
			top 0
			left 0
			height 100%
			border-radius 2px
		.progress 
			background #E02829
			z-index 3
		.dot 
			position absolute
			width 24px
			height 24px
			top 50%
			left 0
			margin-top -12px
			background #E02829
			border-radius 100%
			z-index 4
</style>


// WEBPACK FOOTER //
// com-audio-bar.vue?604f22e8